import { render, staticRenderFns } from "./Wp_pdd_order_page.vue?vue&type=template&id=028e894f&scoped=true&"
import script from "./Wp_pdd_order_page.vue?vue&type=script&lang=js&"
export * from "./Wp_pdd_order_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028e894f",
  null
  
)

export default component.exports